export function setSentences(state, sentences) {
    state.sentences = sentences;
}

export function setSentence(state, sentence) {
    state.sentence = sentence;
}

